"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = isValidEmail;
exports.formatDate = formatDate;
exports.parseDate = parseDate;
exports.sleep = sleep;
exports.generateId = generateId;
exports.omit = omit;
exports.pick = pick;
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
function formatDate(date) {
    return date.toISOString();
}
function parseDate(dateString) {
    return new Date(dateString);
}
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
function generateId() {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}
function omit(obj, keys) {
    const keysToOmit = new Set(keys);
    const entries = Object.entries(obj).filter(([key]) => !keysToOmit.has(key));
    return Object.fromEntries(entries);
}
function pick(obj, keys) {
    const result = {};
    keys.forEach((key) => {
        if (key in obj) {
            result[key] = obj[key];
        }
    });
    return result;
}
//# sourceMappingURL=index.js.map